import { Controller } from '@hotwired/stimulus'
import { variableRegex } from '../../lib/vignette_variables'

// Drives the vignette-aware sample CSV on the variation import form.
// When a vignette is selected it renders a live preview (scenario with
// highlighted {{placeholders}} + variable list) and rewrites the
// "Download sample CSV" link so the sample is scoped to that vignette.
export default class extends Controller {
  static targets = ['select', 'preview', 'scenario', 'variables', 'downloadLink']
  static values = {
    vignettes: Object,
    samplePath: String,
    // Vignette::VARIABLE_PATTERN.source — see lib/vignette_variables.js.
    pattern: String
  }

  connect() {
    this.update()
  }

  update() {
    const id = this.selectTarget.value
    const vignette = id ? this.vignettesValue[id] : null

    if (!vignette) {
      this.previewTarget.classList.add('hidden')
      this.downloadLinkTarget.href = this.samplePathValue
      return
    }

    this.renderScenario(vignette.scenario || '')
    this.renderVariables(vignette.variables || [])
    this.previewTarget.classList.remove('hidden')
    this.downloadLinkTarget.href = `${this.samplePathValue}?vignette_id=${encodeURIComponent(id)}`
  }

  renderScenario(scenario) {
    const escaped = this.escapeHtml(scenario)
    // Highlights exactly what the server will treat as a variable, since the
    // regex comes from the same pattern used to interpolate the scenario.
    this.scenarioTarget.innerHTML = escaped.replace(
      variableRegex(this.patternValue),
      "<mark class='bg-yellow-200 px-1 rounded font-semibold'>{{$1}}</mark>"
    )
  }

  renderVariables(variables) {
    this.variablesTarget.innerHTML = ''

    if (!Array.isArray(variables) || variables.length === 0) {
      const li = document.createElement('li')
      li.textContent = 'No variables defined for this vignette.'
      li.className = 'italic text-gray-500 list-none'
      this.variablesTarget.appendChild(li)
      return
    }

    variables.forEach((variable) => {
      const li = document.createElement('li')
      const code = document.createElement('code')
      code.className = 'text-indigo-600 font-medium'
      code.textContent = `{{${variable}}}`
      li.appendChild(code)
      this.variablesTarget.appendChild(li)
    })
  }

  escapeHtml(text) {
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
  }
}
